import React from "react";
import "./HomePage.css";
import { Link } from "react-router-dom";
import logo from "../../Images/Jayraj_logo.png";
import { useNavigate } from "react-router-dom";

const modules = [
  { title: "Plan Tour", desc: "Create custom itineraries", link: "/tour/plantour" },
  { title: "Group Tour", desc: "Manage group bookings", link: "/tour/grouptour" },
  { title: "Package Tour", desc: "Predefined tour packages", link: "/tour/packagetour" },
  { title: "Weekend Tour", desc: "Short trip management", link: "/tour/weekendtour" },
  { title: "Hotel", desc: "Hotel inventory & pricing", link: "/hotels" },
  { title: "Flight", desc: "Flight bookings", link: "/jayraj-transports/plane" },
  { title: "Bus", desc: "Bus routes & tickets", link: "/jayraj-transports/bus" },
  { title: "Activity", desc: "Activities & experiences", link: "/activities" },
];

const AdminHome = () => {
  const navigate = useNavigate();
  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar">
      <div className="jr-logo" onClick={() => navigate("/")} style={{marginBottom:"1.5rem",marginLeft:"auto",marginRight:"auto"}}>
        <img src={logo} alt="Jayraj Group" />
      </div>
        <nav>
          <Link to="/" className="active">Dashboard</Link>
          {/* <Link to="/admin/tours">Tours</Link> */}
          <Link to="#">Bookings</Link>
          {/* <Link to="/admin/users">Users</Link>
          <Link to="/admin/settings">Settings</Link> */}
        </nav>
      </aside>

      {/* Main */}
      <main className="admin-main">
        <header className="admin-header">
          <h1>Dashboard</h1>
          <span style={{fontSize:"1.1rem",fontWeight:"600"}}>Manual Booking</span>
        </header>

        <section className="module-grid">
          {modules.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="module-link"
            >
              <div className="module-card">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </Link>
          ))}
        </section>
      </main>
    </div>
  );
};

export default AdminHome;
